export const LOCAL_STORAGE_WEATHER_ZIP = 'local-storage-weather-zip';
